;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { FranchiseImages } from '@/lib/types/api/franchise-data';
import { Sponsor } from "@/components/SponsorshipVideoHelpRow/SponsorshipVideoHelpRow";
import { SocialLinkElement } from '@/lib/helpers/get-social-links';

export enum ShowOrFranchiseEnum {
    Show = "show",
    Franchise = "franchise",
}

export interface ShowFlags {
    coming_soon?:      boolean;
    is_new?:           boolean;
    my_station?:       boolean;
    new_episode?:      boolean;
    new_season?:       boolean;
    passport_only?:    boolean;
}

export interface Season {
    cid:     string;
    ordinal: number;
    flags: {
        has_episodes: boolean;
        has_assets: boolean;
    };
}

export interface FeaturedContent {
    url:         string;
    link:        FeaturedContentLink;
    type:        string;
    image:       string;
    title:       string;
    description: string;
}

export interface FeaturedContentLink {
    url:   string;
    title: string;
}

export interface ContentImages {
    "asset-mezzanine-16x9"?: string;
    "show-mezzanine16x9"?: string;
    "show-poster2x3"?: string;
    "white-logo-41"?: string;
    "color-logo-41"?: string;
    background?: string;
}

export interface SupportingLink {
    url?: string;
    image?: string;
    title?: string;
}

export interface SupportingLinks {
    title: string;
    content: SupportingLink[];
    className?: string;
}

export interface PhotoGallery {
    title:   string;
    content: PhotoGalleryContent[];
}

export interface PhotoGalleryContent {
    alt_text:     string;
    image_url:    string;
    credit_text:  string;
    caption_text: string;
}

export interface ShowAirdates {
    content: any[];
}

export interface ShowDetails {
    audience?:               Audience[];
    broadcast_info?:         string;
    cid:                     string;
    countries?:              string[];
    description_long?:       string;
    description_short:       string;
    flags?:                  ShowFlags;
    franchise?:              {
      cid: string;
      slug: string;
      title: string;
      url: string;
      images?: FranchiseImages;
      description_long?: string;
      logo?: string;
      logo_white?: string;
      image?: string;
    } | null;
    funder_information?:     string;
    funder_message?:         string;
    genre?:                  Genre;
    hashtag?:                string;
    image?:                  string;
    images?:                 ShowDetailsImages;
    is_kids?:                boolean;
    item_type:               'show';
    links?:                  LinkElement[];
    local_content_stations?: any[];
    logo_black?:             string;
    logo_color?:             string;
    logo_white?:             string;
    nola_root?:              string;
    popularity?:             string | boolean | number | null;
    popularity_position?:    number | null;
    poster?:                 string;
    premiere_date?:          string;
    seasons_count?:          number;
    slug:                    string;
    social_links?:           SocialLinkElement[];
    sort_episodes_descending?: boolean;
    sponsor_logos?:          Sponsor[];
    test_data?:              boolean;
    title:                   string;
    title_sortable?:         string;
    tracking_ga_event?:      string;
    tracking_ga_page?:       string;
    url?:                    string;
    website?:                string;
}

export interface Audience {
    scope:   string;
    station: null | {
        cid: string;
        call_sign: string;
        short_common_name: string;
    };
}

export interface Genre {
    cid:   string;
    slug:  string;
    title: string;
    url:   string;
}

export interface ShowDetailsImages {
    "show-mezzanine16x9"?:          string;
    "show-banner"?:                string;
    "show-poster2x3":              string;
    "white-logo-41"?:              string;
    "color-logo-41"?:              string;
    background?:                   string;
    "black-logo-41"?:              string;
    "show-logo"?:                  string;
    "show-showcase"?:              string;
    "show-white-logo"?:            string;
    "show-black-logo"?:            string;
    "show-color-logo"?:            string;
    "asset-kids-mezzanine1-16x9"?: string;
}

export interface LinkElement {
    value:      string;
    profile:    string;
    updated_at: string;
}

export interface ShowRow {
    title:      string;
    title_link: string;
    content:    ShowRowContent[];
}

export interface ShowRowContent {
    audience:             Audience[];
    cid:                  string;
    countries?:           string[];
    description_long?:    string;
    description_short?:   string;
    flags?:               ShowFlags;
    franchise:            Genre | null;
    genre:                Genre;
    image?:               string;
    images:               ShowDetailsImages;
    item_type:            ShowOrFranchiseEnum;
    links:                LinkElement[];
    popularity_position:  number | null;
    popularity:           null;
    premiere_date?:       string;
    slug:                 string;
    title_sortable:       string;
    title:                string;
    tracking_ga_event:    string;
    tracking_ga_page:     string;
    url:                  string;
    recommendation_id?:   string;
}

export interface SupportingText {
    title:          string;
    text:           string | null;
    text_secondary: string | null;
    className?:     string;
}
export interface SupportingTextCSResponse {
    label:          string;
    text:           string;
    text_secondary: string;
}

export interface FeaturedPreview {
    cid: string;
    slug: string;
    title: string;
    videoType: 'CLIP' | 'PREVIEW' | 'FULL_LENGTH';
    mezzanine16x9ImageUrl: string;
    availability: string;
}

export interface ShowFeaturedPreviewResponse {
    data: {
      showContext: {
        featuredPreview: FeaturedPreview
      }
    }
}

export interface ShowCollectionData {
    cid:                string;
    slug:               string;
    title:              string;
    title_sortable:     string;
    flags:              ShowFlags;
    premiere_date?:     string;
    show:               ShowRowContent;
    description_short:  string;
    description_long:   string;
    featured:           boolean;
    images:             ContentImages;
    item_type:          string;
    links:              LinkElement[];
    tracking_ga_event:  string;
    tracking_ga_page:   string;
}

export interface BroadcastInfo {
    'broadcast-time': string;
}
